import { render, staticRenderFns } from "./Card1.vue?vue&type=template&id=3678a2fe&scoped=true&"
import script from "./Card1.vue?vue&type=script&lang=js&"
export * from "./Card1.vue?vue&type=script&lang=js&"
import style0 from "./Card1.vue?vue&type=style&index=0&id=3678a2fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678a2fe",
  null
  
)

export default component.exports